// Intel HEX (.hex) parser for AVR / Arduino microcontrollers

export function parseHex(hexText) {
  const lines = hexText.split(/\r?\n/);
  const data = new Uint8Array(32768); // 32KB max for ATmega328P
  data.fill(0xFF); // Default flash unprogrammed state

  let maxAddress = 0;
  let segmentAddr = 0;

  for (let lineNum = 0; lineNum < lines.length; lineNum++) {
    const line = lines[lineNum].trim();
    if (!line.startsWith(':')) continue;

    const len = parseInt(line.substring(1, 3), 16);
    const addr = parseInt(line.substring(3, 7), 16);
    const type = parseInt(line.substring(7, 9), 16);

    if (type === 0x01) {
      // End of File
      break;
    } else if (type === 0x00) {
      // Data Record
      const fullAddr = segmentAddr + addr;
      for (let i = 0; i < len; i++) {
        const byteVal = parseInt(line.substring(9 + i * 2, 11 + i * 2), 16);
        if (fullAddr + i < data.length) {
          data[fullAddr + i] = byteVal;
          if (fullAddr + i > maxAddress) {
            maxAddress = fullAddr + i;
          }
        }
      }
    } else if (type === 0x02) {
      // Extended Segment Address
      segmentAddr = parseInt(line.substring(9, 13), 16) << 4;
    } else if (type === 0x04) {
      // Extended Linear Address
      segmentAddr = parseInt(line.substring(9, 13), 16) << 16;
    }
  }

  // Return trimmed slice up to highest written byte + 1
  const trimmedLength = maxAddress > 0 ? maxAddress + 1 : 0;
  return {
    data: data.slice(0, trimmedLength),
    size: trimmedLength
  };
}
